import translator from '@/locales';

export default function required(
  message = translator.t('VALIDATION_REQUIRED_ERR'),
) {
  return {
    required: true,
    message,
    trigger: 'blur',
  };
}
